// JASI Service Page — FAQ Accordion
document.querySelectorAll('.jasi-service-page [data-accordion]').forEach(function (acc) {
  acc.querySelectorAll('.item').forEach(function (item) {
    var head = item.querySelector('.head');
    var panel = item.querySelector('.panel');
    if (!head || !panel) return;
    head.addEventListener('click', function () {
      var isOpen = item.classList.contains('open');
      acc.querySelectorAll('.item.open').forEach(function (o) {
        if (o !== item) { o.classList.remove('open'); var p = o.querySelector('.panel'); if (p) p.style.maxHeight = null; }
      });
      if (isOpen) {
        item.classList.remove('open');
        panel.style.maxHeight = null;
      } else {
        item.classList.add('open');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });
});
